import React from 'react';
import styled from 'styled-components';
import { InnerLayout } from '../styles/Layouts';
import card from '../img/creditcard.svg';

function CardSection() {
    return ( 
    <CardSectionStyled>
        <InnerLayout>
            <div className = "card-container" >
                <div className = "card-left" >
                    <h2 className = "secondary-heading" > 
                    One card for all your payments 
                    </h2>  
                    <p >
                        Lorem ipsum, dolor sit amet consectetur adipisicing elit.Deserunt reprehenderit doloremque quia ? Odit illo, tempore quod vero exercitationem,
                        voluptatum laudantium quo harum, adipisci tenetur eum. 
                    </p>
                </div > 
                <div className = "card-right" >
                    <img src = { card } alt = "" />
                    </div> </div >
        </InnerLayout>  
    </CardSectionStyled >
    )
}

const CardSectionStyled = styled.section `
    .card-container{
        width: 100% !important;
        max-width: 100%;
        display: flex;
        /* grid-template-columns: repeat(2, 1fr); */
        @media screen and (max-width: 845px){
            flex-direction: column;
            grid-template-columns: repeat(1, 1fr);
        }
        .card-right{
            width: 50%;
            display: flex;
            justify-content: flex-end;
            @media screen and (max-width: 845px){
                width: 100%;
            }
            img{
                width: 100%;
                filter: drop-shadow(0px 50px 100px rgba(22, 25, 79, 0.15));
            }
        }
        
        .card-left{
            width: 50%;
            padding: 2rem;
            @media screen and (max-width: 845px){
                width: 100%;
                padding-left: 0;
            }
            p{
                width: 100% !important;
            }
        }
    }
`;

export default CardSection